import React from 'react'
import PropTypes from 'prop-types'
import CheckHotlineItem from "./CheckHotlineItem"

CheckHotlineBody.propTypes = {
    error: PropTypes.string,
    listJobCheck: PropTypes.array
}

function CheckHotlineBody(props) {
    const {error, listJobCheck} = props

    return (
        <tbody className="CustomersBody">
        {
            !!listJobCheck && listJobCheck.length > 0 ? listJobCheck.map((item, index) => (
                <CheckHotlineItem key={index} index={index} item={item}/>
            )) : <tr className="NoRecord">
                <td colSpan={7}>Không có bản ghi nào.</td>
            </tr>
        }

        {
            !!error && error.length > 0 && <tr className="NoRecord Error">
                <td colSpan={8}>{error}</td>
            </tr>
        }
        </tbody>
    )
}

export default CheckHotlineBody